// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-divider[data-v-fef4289e] {\n  margin: 0 0 1.2rem 0;\n}", ""]);
// Exports
module.exports = exports;
